import React, { useRef, useEffect, useState } from 'react';
import { partners } from '../data/mock';

const PartnersSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="bg-black py-24 md:py-32 px-6 md:px-12 lg:px-24"
    >
      <div className="max-w-[1800px] mx-auto">
        {/* Section Title */}
        <div
          className={`text-center mb-16 md:mb-20 transition-all duration-1000 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'
          }`}
        >
          <h2
            className="text-white text-4xl md:text-5xl lg:text-6xl  tracking-[0.15em]"
            style={{ fontFamily: "'Spectral SC', serif" }}
          >
            OUR PARTNERS
          </h2>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-6 md:gap-8 lg:gap-10">
          {partners.map((partner, index) => (
            <div
              key={partner.name}
              className={`flex items-center justify-center transition-all duration-700 ${
                isVisible
                  ? 'translate-y-0 opacity-100'
                  : 'translate-y-8 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 40}ms` }}
            >
              <div className="group cursor-pointer w-full">
                <div className="relative aspect-[3/2] flex items-center justify-center opacity-100 transition-all duration-500 text-white">
                  <img 
                    src={`${process.env.PUBLIC_URL}${partner.logo}`} 
                    alt={partner.name}
                    className="max-w-full max-h-full object-contain"
                    onError={(e) => {
                      console.log(`Failed to load image: ${partner.logo}`);
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
